/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blockautomaticmoveupdaysinadvance6Inputs */

const en__field_blockautomaticmoveupdaysinadvance6 = /** @type {(inputs: _Field_Blockautomaticmoveupdaysinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto waiting list update period`)
};

const de__field_blockautomaticmoveupdaysinadvance6 = /** @type {(inputs: _Field_Blockautomaticmoveupdaysinadvance6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Wartenlisten Update Frist`)
};

/**
* | output |
* | --- |
* | "auto waiting list update period" |
*
* @param {_Field_Blockautomaticmoveupdaysinadvance6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_blockautomaticmoveupdaysinadvance6 = /** @type {((inputs?: _Field_Blockautomaticmoveupdaysinadvance6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blockautomaticmoveupdaysinadvance6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_blockautomaticmoveupdaysinadvance6(inputs)
	return de__field_blockautomaticmoveupdaysinadvance6(inputs)
});
export { _field_blockautomaticmoveupdaysinadvance6 as "_field_blockAutomaticMoveUpDaysInAdvance" }